import React from "react";

export const MinicartDiscounts = ({ cart_subtotal, settings }) => {
    const { blocks } = settings;
    const freeShippingBlock = blocks.find(block => block.type === 'free_shipping');

    let message = freeShippingBlock.settings.discount_message;

    const threshold = freeShippingBlock.settings.discount_threshold;

    if (cart_subtotal >= threshold) {
        message = freeShippingBlock.settings.discount_message_success;
    } else {
        const currencySymbol = window.Alpine?.store('currency').getCurrencySymbol();
        const diff = threshold - cart_subtotal;
        message = freeShippingBlock.settings.discount_message.replace('{difference}', `${currencySymbol}${diff.toFixed(2)}`);
    }

    return (
        <p className={`${freeShippingBlock.settings.discount_message_style} minicart__discounts`}>{message}</p>
    );
};